import mitt from "mitt";

const eventBus = mitt();

eventBus.once = (eventName, handler) => {
  const wrappedHandler = (...args) => {
    handler(...args);
    eventBus.off(eventName, wrappedHandler);
  };
  eventBus.on(eventName, wrappedHandler);
};

export default eventBus;
